import { NgModule, ApplicationRef } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import "hammerjs";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Layout
import { LayoutComponent } from "./layout/layout.component";
import { PreloaderDirective } from "./layout/preloader.directive";
// Header
import { AppHeaderComponent } from "./layout/header/header.component";
// Sidenav
import { AppSidenavComponent } from "./layout/sidenav/sidenav.component";
import { ToggleOffcanvasNavDirective } from "./layout/sidenav/toggle-offcanvas-nav.directive";
import { AutoCloseMobileNavDirective } from "./layout/sidenav/auto-close-mobile-nav.directive";
import { AppSidenavMenuComponent } from "./layout/sidenav/sidenav-menu/sidenav-menu.component";
import { AccordionNavDirective } from "./layout/sidenav/sidenav-menu/accordion-nav.directive";
import { AppendSubmenuIconDirective } from "./layout/sidenav/sidenav-menu/append-submenu-icon.directive";
import { HighlightActiveItemsDirective } from "./layout/sidenav/sidenav-menu/highlight-active-items.directive";
// Customizer
import { AppCustomizerComponent } from "./layout/customizer/customizer.component";
import { ToggleQuickviewDirective } from "./layout/customizer/toggle-quickview.directive";
// Footer
import { AppFooterComponent } from "./layout/footer/footer.component";
// Search Overaly
import { AppSearchOverlayComponent } from "./layout/search-overlay/search-overlay.component";
import { SearchOverlayDirective } from "./layout/search-overlay/search-overlay.directive";
import { OpenSearchOverlaylDirective } from "./layout/search-overlay/open-search-overlay.directive";

// Pages

import { DashboardComponent } from "./dashboard/dashboard.component";
import { PageLayoutFullscreenComponent } from "./page-layouts/fullscreen/fullscreen.component";
import { DragulaModule } from "ng2-dragula";
import { LoaderComponent } from "./loader/loader.component";
import { LoaderService } from "./loader/loader.service";
import { dialogComponent } from "./dialog/dialog.component";
import { CommonService } from "./shared/services/common.service";
import { CommonModule } from "@angular/common";
// Sub modules
import { MatDialogModule } from "@angular/material/dialog";

import { LayoutModule } from "./layout/layout.module";
import { SharedModule } from "./shared/shared.module";
import { UsersListComponent } from "./users/usersList.component";
import { usersResultService } from "./usersResultService";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CustomDatePipe } from "./datex.pipe";

// hmr
import { removeNgStyles, createNewHosts } from "@angularclass/hmr";
import { CreateOrUpdateUserComponent } from "./users/createOrUpdateUser.component";
import { ConfigurationsComponent } from "./configurations/configurations.component";
import { ConfigsListComponent } from "./configurations/configsList.component";
import { EmailTemplateListComponent } from "./emailTemplates/emailTemplateList.component";
import { EmailTemplateComponent } from "./emailTemplates/emailTemplate.component";
import { ActivityLogComponent } from "./activityLog/activityLog.component";
import { EditActivityLogComponent } from "./activityLog/editActivityLog.component";
import { FileUploadModule } from "ng2-file-upload";
import { DocumentsComponent } from "./documents/documents.component";
import { ParametersComponent } from "./parameters/parameters.component";
import { SearchComponent } from "./search/search.component";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatListModule } from "@angular/material/list";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import {
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { ModalModule } from "ngx-bootstrap/modal";
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
// import { NgxEditorModule } from 'ngx-editor';
import { CKEditorModule } from "ng2-ckeditor";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
// Removed TooltipModule import as it is not exported by "ng2-tooltip-directive"
import {
  SocialLoginModule,
  AuthServiceConfig,
  LoginOpt,
} from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { APPCONFIG } from "./config";
import { TokenInterceptor } from "./shared/services/token.interceptor";
import { HttpClientModule } from "@angular/common/http";
import { AuthInterceptor } from './auth.interceptor';
// import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { NgxSpinnerModule } from 'ngx-spinner';
import {OktaAuthModule, OKTA_CONFIG} from '@okta/okta-angular';
import {OktaAuth} from '@okta/okta-auth-js';
import { Router } from "@angular/router";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}

// const oktaAuth =new OktaAuth({
//   issuer: 'https://dev-46482522.okta.com/oauth2/default',
//   clientId: '0oanoj1qieVrA3apr5d7',
//   redirectUri: window.location.origin + '/login/callback',
//   scopes: ['openid', 'profile', 'offline_access'],
//   //add access token
// });

const oktaAuth =new OktaAuth({
  issuer: 'https://arcelik.okta-emea.com/oauth2/aus9nnvvqk66SpDAV0i7',
  clientId: '0oahgde11bi2UAgFw0i7',
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid','profile','email', 'userinfo','serviceDocs'],
  //add access token
});

function customAuthRequired(oktaAuth, injector){
  const router = injector.get(Router);
  console.log('[OKTA] unauthenticated - redirecting to /extra/login');
  router.navigate(['/extra/login']);
}

const googleLoginOptions: LoginOpt = {
  scope: "profile email", 
};

let config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
      APPCONFIG.google_client_id,
      googleLoginOptions
    ),
  },
]);

export function provideConfig() {
  return config;
}

@NgModule({
  imports: [
    // Removed TooltipModule from imports array
    BrowserModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatDialogModule,
    FormsModule,
    DragulaModule.forRoot(),
    ModalModule.forRoot(),
    MatRippleModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    OktaAuthModule,
    AppRoutingModule,
    // InfiniteScrollModule,
    // NgxSpinnerModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    // Sub modules
    LayoutModule,
    SharedModule,
    NgxDatatableModule,
    FileUploadModule,
    CKEditorModule,
    SocialLoginModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    AppComponent,
    CustomDatePipe,
    // Layout
    LayoutComponent,
    PreloaderDirective,
    // Header
    AppHeaderComponent,
    // Sidenav
    AppSidenavComponent,
    ToggleOffcanvasNavDirective,
    AutoCloseMobileNavDirective,
    AppSidenavMenuComponent,
    AccordionNavDirective,
    AppendSubmenuIconDirective,
    HighlightActiveItemsDirective,
    // Customizer
    AppCustomizerComponent,
    ToggleQuickviewDirective,
    // Footer
    AppFooterComponent,
    // Search overlay
    AppSearchOverlayComponent,
    SearchOverlayDirective,
    OpenSearchOverlaylDirective,
    //
    LoaderComponent,
    dialogComponent,

    DashboardComponent,
    UsersListComponent,
    // Pages
    PageLayoutFullscreenComponent,
    CreateOrUpdateUserComponent,
    ConfigurationsComponent,
    ConfigsListComponent,
    EmailTemplateListComponent,
    EmailTemplateComponent,
    ActivityLogComponent,
    DocumentsComponent,
    ParametersComponent,
    SearchComponent,
    EditActivityLogComponent,
  ],
  providers: [
    LoaderService,
    CommonService,
    usersResultService,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth ,
        // onAuthRequired: customAuthRequired,
        // postLoginRedirectUri: '/app/documents',
      },
    },
    //,{provide: UrlSerializer, useClass: LowerCaseUrlSerializer}
  ],
  entryComponents: [dialogComponent],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log("HMR store", store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(
      (cmp) => cmp.location.nativeElement
    );
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}
